const PassionOption = Object.freeze({
  LOVE: 'LOVE',
  HATE: 'HATE',
  LIKE: 'LIKE',
  NOT_LIKE: 'NOT_LIKE'
})
export default PassionOption
// RESERVE BELOW
